import { useEffect, useState } from 'react';

import APIMatches from '../../api/matches';
import ItemImage from '../../components/ItemImage';
import { formatValueInPercentage } from '../../helpers/formatValueinPercentage';
import { statsOrder, labelMap } from '../../constants/matchStats';

export const Stats = ({ store }) => {
    const [stats, setStats] = useState(null);
    const [teams, setTeams] = useState(null);

    useEffect(() => {
        const getStatistics = async () => {
            try {
                const res = await APIMatches.getMatchStats(store.selectedMatch.id);
                const data = res?.data;
                if (data?.home_team_ranking && data?.away_team_ranking) {
                    const home = data.home_team_ranking;
                    const away = data.away_team_ranking;

                    const merged = statsOrder
                        .filter((key) => key in home && key in away)
                        .map((key) => ({
                            name: key,
                            label: labelMap[key] || key,
                            home: home[key],
                            away: away[key],
                        }));

                    setStats(merged);
                }
                if (data?.home_team && data?.away_team) {
                    setTeams({ home: data?.home_team, away: data?.away_team });
                }
            } catch (e) {
                console.log(e);
            }
        };

        if (store?.selectedMatch) getStatistics();
    }, [store]);

    if (stats === null) return null;

    return (
        <div className="stats-wrapper">
            {teams && (
                <div className="team-logos">
                    <ItemImage imgSrc={teams?.home?.image_url} listView={true} />
                    VS.
                    <ItemImage imgSrc={teams?.away.image_url} listView={true} />
                </div>
            )}
            <div className="stats">
                {stats.map((stat, index) => (
                    <div
                        className={`stat-item ${index % 2 === 0 ? 'even' : 'odd'}`}
                        key={stat.name}
                    >
                        <p className="stat-home">{formatValueInPercentage(stat.name, stat.home)}</p>
                        <p className="stat-name">{stat.label}</p>
                        <p className="stat-away">{formatValueInPercentage(stat.name, stat.away)}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};
